export default "__VITE_ASSET__04154687__"